/**
 * Card Component
 * Reusable card container with optional interactive hover effects
 *
 * @param {Object} props
 * @param {ReactNode} props.children - Card content
 * @param {boolean} props.interactive - Enable hover effects and cursor pointer
 * @param {Function} props.onClick - Click handler (auto-enables interactive)
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 */
const Card = ({
  children,
  interactive = false,
  onClick,
  className = '',
  style = {}
}) => {
  // Auto-enable interactive if onClick is provided
  const isInteractive = interactive || !!onClick

  // Build CSS classes
  const classes = [
    'psyber-card',
    isInteractive && 'psyber-card-interactive',
    className
  ].filter(Boolean).join(' ')

  // Handle click
  const handleClick = (e) => {
    if (onClick) {
      onClick(e)
    }
  }

  return (
    <div
      className={classes}
      onClick={handleClick}
      style={{
        position: 'relative', // Required for ::before pseudo-element
        ...style
      }}
    >
      {children}
    </div>
  )
}

export default Card
